import React, { useEffect, useState } from 'react';

// components
import { Button } from 'shared/components/bulma/button';
import { Modal, ModalContent, ModalControl } from 'shared/components/bulma/modal';
import ArchiveReasons from "./archive-reasons";

// functions
import { UseToast, ShowErrorToast, ShowSuccessToast } from 'shared/functions';
// helpers
import * as helper from "../../../../containers/Search/EditProduct/helper";

// pipes
import { titleCasePipe } from "shared/pipes";

const ModalArchive = ({ modal, handleModal, barcode }) => {
    const [reasons, setReasons] = useState([]);
    const [reason, setReason] = useState("lost");

    useEffect(() => {
        UseToast();
        const options = ['damaged', 'lost', 'out_of_fashion', 'worn_out'];
        const reasons = [];
        for (const option of options) {
            reasons.push({ value: option, label: titleCasePipe.transform(option) });
        }
        setReasons(reasons);
    }, []);


    const reset = () => {
        handleModal(false);
    }

    const handleArchive = async () => {
        const archived = await helper.archiveProduct(barcode, reason);
        // TO DO:
        // 1: close the modal
        handleModal(false);
        // 2: success toast
        if (archived) {
            ShowSuccessToast("Success!")
        } else {
            ShowErrorToast("Some problem during the archiving!")
        }
    }
    const handleChange = async (reason) => {
        setReason(reason);
    }

    return (
        <Modal title="Archive modal" isActive={modal} handleAccept={handleArchive} handleReject={reset}>
            <ModalContent>

                <ArchiveReasons options={reasons} reason={reason} onChange={handleChange}></ArchiveReasons>

            </ModalContent>

            <ModalControl>

                <Button className="is-info" name="reset" onClick={reset}>
                    Close
                </Button>

                <Button className="is-primary" name="submit" onClick={handleArchive}>
                    Archive
                </Button>

            </ModalControl>

        </Modal>
    );
}


export default ModalArchive;
